/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Chkk Admin API v1.0
 * Chkk Admin API for Kubernetes deployment and upgrade safety.
 * OpenAPI spec version: v1.0
 */
import useSwr from 'swr';
import type { Arguments, Key, SWRConfiguration } from 'swr';

import useSWRMutation from 'swr/mutation';
import type { SWRMutationConfiguration } from 'swr/mutation';

import type {
  Account,
  Addon,
  AddonImageDetails,
  AddonInstance,
  AdminSubscription,
  CloudConnection,
  CloudConnectionAction,
  Cluster,
  CreateCloudConnectionActionRequest,
  CreateSubscriptionRequest,
  CreateUpgradePlanStagesRequest,
  CreateUpgradeTemplateStagesRequest,
  GetTeamMemberImpersonationTokenResponse,
  GlobalListUpgradeAssessmentsParams,
  GlobalListUpgradeTemplatesParams,
  GlobalListUpgradesParams,
  Integration,
  LARStatus,
  ListAccountsParams,
  ListAccountsResponse,
  ListAddonInstancesParams,
  ListAddonInstancesResponse,
  ListAddonResponse,
  ListAddonsParams,
  ListCloudConnectionsParams,
  ListCloudConnectionsResponse,
  ListClustersParams,
  ListClustersResponse,
  ListIntegrationsParams,
  ListIntegrationsResponse,
  ListLARStatusParams,
  ListLARStatusResponse,
  ListOrganizationsParams,
  ListOrganizationsResponse,
  ListSubscriptionsParams,
  ListSubscriptionsResponse,
  ListTeamMembersParams,
  ListTeamMembersResponse,
  ListTeamsParams,
  ListTeamsResponse,
  ListUpgradeAssessmentStagesResponse,
  ListUpgradeAssessmentsParams,
  ListUpgradeAssessmentsResponse,
  ListUpgradePlanStagesResponse,
  ListUpgradePlansResponse,
  ListUpgradeTemplateStagesResponse,
  ListUpgradeTemplatesParams,
  ListUpgradeTemplatesResponse,
  ListUpgradesParams,
  ListUserResponse,
  ListUsersParams,
  Organization,
  Team,
  UpdateClusterRequest,
  UpdateLARStatusRequest,
  UpdateSubscriptionRequest,
  UpdateUpgradeAssessmentRequest,
  UpdateUpgradeAssessmentStagesRequest,
  UpdateUpgradePlanRequest,
  UpdateUpgradePlanStagesRequest,
  UpdateUpgradeTemplateRequest,
  UpdateUpgradeTemplateStagesRequest,
  UpgradeAssessmentAdminView,
  UpgradeAssessmentGenerationOutputDocument,
  UpgradePlanAdminView,
  UpgradePlanGenerationOutputDocument,
  UpgradeSelections,
  UpgradeTemplateAdminView,
  UpgradeTemplateGenerationOutputDocument,
  User,
} from './admin-models';

import { customAdminApiInstance } from './custom-instance';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * List organizations
 */
export const listOrganizations = (params?: ListOrganizationsParams) => {
  return customAdminApiInstance<ListOrganizationsResponse>({
    url: `/organizations`,
    method: 'GET',
    params,
  });
};

export const getListOrganizationsKey = (params?: ListOrganizationsParams) =>
  [`/organizations`, ...(params ? [params] : [])] as const;

export type ListOrganizationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOrganizations>>
>;
export type ListOrganizationsQueryError = unknown;

export const useListOrganizations = <TError = unknown>(
  params?: ListOrganizationsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listOrganizations>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListOrganizationsKey(params) : null));
  const swrFn = () => listOrganizations(params);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get details of a specific organization
 */
export const getOrganization = (organizationId: string) => {
  return customAdminApiInstance<Organization>({
    url: `/organizations/${organizationId}`,
    method: 'GET',
  });
};

export const getGetOrganizationKey = (organizationId: string) =>
  [`/organizations/${organizationId}`] as const;

export type GetOrganizationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganization>>
>;
export type GetOrganizationQueryError = unknown;

export const useGetOrganization = <TError = unknown>(
  organizationId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getOrganization>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!organizationId;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetOrganizationKey(organizationId) : null));
  const swrFn = () => getOrganization(organizationId);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * List Subscriptions in an organization
 */
export const listSubscriptions = (
  organizationId: string,
  params?: ListSubscriptionsParams,
) => {
  return customAdminApiInstance<ListSubscriptionsResponse>({
    url: `/organizations/${organizationId}/subscriptions`,
    method: 'GET',
    params,
  });
};

export const getListSubscriptionsKey = (
  organizationId: string,
  params?: ListSubscriptionsParams,
) =>
  [
    `/organizations/${organizationId}/subscriptions`,
    ...(params ? [params] : []),
  ] as const;

export type ListSubscriptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSubscriptions>>
>;
export type ListSubscriptionsQueryError = unknown;

export const useListSubscriptions = <TError = unknown>(
  organizationId: string,
  params?: ListSubscriptionsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listSubscriptions>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!organizationId;
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled ? getListSubscriptionsKey(organizationId, params) : null);
  const swrFn = () => listSubscriptions(organizationId, params);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Create an internal subscription in an organization.
 */
export const createSubscription = (
  organizationId: string,
  createSubscriptionRequest: CreateSubscriptionRequest,
) => {
  return customAdminApiInstance<void>({
    url: `/organizations/${organizationId}/subscriptions`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createSubscriptionRequest,
  });
};

export const getCreateSubscriptionMutationFetcher = (
  organizationId: string,
) => {
  return (_: Key, { arg }: { arg: CreateSubscriptionRequest }) => {
    return createSubscription(organizationId, arg);
  };
};
export const getCreateSubscriptionMutationKey = (organizationId: string) =>
  [`/organizations/${organizationId}/subscriptions`] as const;

export type CreateSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSubscription>>
>;
export type CreateSubscriptionMutationError = unknown;

export const useCreateSubscription = <TError = unknown>(
  organizationId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof createSubscription>>,
      TError,
      Key,
      CreateSubscriptionRequest,
      Awaited<ReturnType<typeof createSubscription>>
    > & { swrKey?: string };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getCreateSubscriptionMutationKey(organizationId);
  const swrFn = getCreateSubscriptionMutationFetcher(organizationId);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get a subscription in an account
 */
export const getSubscription = (
  organizationId: string,
  subscriptionId: string,
) => {
  return customAdminApiInstance<AdminSubscription>({
    url: `/organizations/${organizationId}/subscriptions/${subscriptionId}`,
    method: 'GET',
  });
};

export const getGetSubscriptionKey = (
  organizationId: string,
  subscriptionId: string,
) =>
  [`/organizations/${organizationId}/subscriptions/${subscriptionId}`] as const;

export type GetSubscriptionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSubscription>>
>;
export type GetSubscriptionQueryError = unknown;

export const useGetSubscription = <TError = unknown>(
  organizationId: string,
  subscriptionId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getSubscription>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(organizationId && subscriptionId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled ? getGetSubscriptionKey(organizationId, subscriptionId) : null);
  const swrFn = () => getSubscription(organizationId, subscriptionId);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Update an internal subscription in an account
 */
export const updateSubscription = (
  organizationId: string,
  subscriptionId: string,
  updateSubscriptionRequest: UpdateSubscriptionRequest,
) => {
  return customAdminApiInstance<void>({
    url: `/organizations/${organizationId}/subscriptions/${subscriptionId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateSubscriptionRequest,
  });
};

export const getUpdateSubscriptionMutationFetcher = (
  organizationId: string,
  subscriptionId: string,
) => {
  return (_: Key, { arg }: { arg: UpdateSubscriptionRequest }) => {
    return updateSubscription(organizationId, subscriptionId, arg);
  };
};
export const getUpdateSubscriptionMutationKey = (
  organizationId: string,
  subscriptionId: string,
) =>
  [`/organizations/${organizationId}/subscriptions/${subscriptionId}`] as const;

export type UpdateSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSubscription>>
>;
export type UpdateSubscriptionMutationError = unknown;

export const useUpdateSubscription = <TError = unknown>(
  organizationId: string,
  subscriptionId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateSubscription>>,
      TError,
      Key,
      UpdateSubscriptionRequest,
      Awaited<ReturnType<typeof updateSubscription>>
    > & { swrKey?: string };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getUpdateSubscriptionMutationKey(organizationId, subscriptionId);
  const swrFn = getUpdateSubscriptionMutationFetcher(
    organizationId,
    subscriptionId,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * List accounts in an organization
 */
export const listAccounts = (
  organizationId: string,
  params?: ListAccountsParams,
) => {
  return customAdminApiInstance<ListAccountsResponse>({
    url: `/organizations/${organizationId}/accounts`,
    method: 'GET',
    params,
  });
};

export const getListAccountsKey = (
  organizationId: string,
  params?: ListAccountsParams,
) =>
  [
    `/organizations/${organizationId}/accounts`,
    ...(params ? [params] : []),
  ] as const;

export type ListAccountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAccounts>>
>;
export type ListAccountsQueryError = unknown;

export const useListAccounts = <TError = unknown>(
  organizationId: string,
  params?: ListAccountsParams,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof listAccounts>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!organizationId;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListAccountsKey(organizationId, params) : null));
  const swrFn = () => listAccounts(organizationId, params);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get details about a specific account
 */
export const getAccount = (accountId: string) => {
  return customAdminApiInstance<Account>({
    url: `/accounts/${accountId}`,
    method: 'GET',
  });
};

export const getGetAccountKey = (accountId: string) =>
  [`/accounts/${accountId}`] as const;

export type GetAccountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccount>>
>;
export type GetAccountQueryError = unknown;

export const useGetAccount = <TError = unknown>(
  accountId: string,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getAccount>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!accountId;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetAccountKey(accountId) : null));
  const swrFn = () => getAccount(accountId);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * List teams in an account
 */
export const listTeams = (accountId: string, params?: ListTeamsParams) => {
  return customAdminApiInstance<ListTeamsResponse>({
    url: `/accounts/${accountId}/teams`,
    method: 'GET',
    params,
  });
};

export const getListTeamsKey = (accountId: string, params?: ListTeamsParams) =>
  [`/accounts/${accountId}/teams`, ...(params ? [params] : [])] as const;

export type ListTeamsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTeams>>
>;
export type ListTeamsQueryError = unknown;

export const useListTeams = <TError = unknown>(
  accountId: string,
  params?: ListTeamsParams,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof listTeams>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!accountId;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListTeamsKey(accountId, params) : null));
  const swrFn = () => listTeams(accountId, params);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get details about a specific team
 */
export const getTeam = (accountId: string, teamId: string) => {
  return customAdminApiInstance<Team>({
    url: `/accounts/${accountId}/teams/${teamId}`,
    method: 'GET',
  });
};

export const getGetTeamKey = (accountId: string, teamId: string) =>
  [`/accounts/${accountId}/teams/${teamId}`] as const;

export type GetTeamQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeam>>
>;
export type GetTeamQueryError = unknown;

export const useGetTeam = <TError = unknown>(
  accountId: string,
  teamId: string,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getTeam>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!(accountId && teamId);
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetTeamKey(accountId, teamId) : null));
  const swrFn = () => getTeam(accountId, teamId);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * List members in a team
 */
export const listTeamMembers = (
  accountId: string,
  teamId: string,
  params?: ListTeamMembersParams,
) => {
  return customAdminApiInstance<ListTeamMembersResponse>({
    url: `/accounts/${accountId}/teams/${teamId}/members`,
    method: 'GET',
    params,
  });
};

export const getListTeamMembersKey = (
  accountId: string,
  teamId: string,
  params?: ListTeamMembersParams,
) =>
  [
    `/accounts/${accountId}/teams/${teamId}/members`,
    ...(params ? [params] : []),
  ] as const;

export type ListTeamMembersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTeamMembers>>
>;
export type ListTeamMembersQueryError = unknown;

export const useListTeamMembers = <TError = unknown>(
  accountId: string,
  teamId: string,
  params?: ListTeamMembersParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listTeamMembers>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!(accountId && teamId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled ? getListTeamMembersKey(accountId, teamId, params) : null);
  const swrFn = () => listTeamMembers(accountId, teamId, params);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get an access token to impersonate a user as a member of that account/team
 */
export const getTeamMemberImpersonationToken = (
  accountId: string,
  teamId: string,
  userId: string,
) => {
  return customAdminApiInstance<GetTeamMemberImpersonationTokenResponse>({
    url: `/accounts/${accountId}/teams/${teamId}/members/${userId}/impersonation_token`,
    method: 'GET',
  });
};

export const getGetTeamMemberImpersonationTokenKey = (
  accountId: string,
  teamId: string,
  userId: string,
) =>
  [
    `/accounts/${accountId}/teams/${teamId}/members/${userId}/impersonation_token`,
  ] as const;

export type GetTeamMemberImpersonationTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeamMemberImpersonationToken>>
>;
export type GetTeamMemberImpersonationTokenQueryError = unknown;

export const useGetTeamMemberImpersonationToken = <TError = unknown>(
  accountId: string,
  teamId: string,
  userId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getTeamMemberImpersonationToken>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(accountId && teamId && userId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getGetTeamMemberImpersonationTokenKey(accountId, teamId, userId)
        : null);
  const swrFn = () =>
    getTeamMemberImpersonationToken(accountId, teamId, userId);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * List integrations in an account
 */
export const listIntegrations = (
  accountId: string,
  params?: ListIntegrationsParams,
) => {
  return customAdminApiInstance<ListIntegrationsResponse>({
    url: `/accounts/${accountId}/integrations`,
    method: 'GET',
    params,
  });
};

export const getListIntegrationsKey = (
  accountId: string,
  params?: ListIntegrationsParams,
) =>
  [`/accounts/${accountId}/integrations`, ...(params ? [params] : [])] as const;

export type ListIntegrationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listIntegrations>>
>;
export type ListIntegrationsQueryError = unknown;

export const useListIntegrations = <TError = unknown>(
  accountId: string,
  params?: ListIntegrationsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listIntegrations>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!accountId;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListIntegrationsKey(accountId, params) : null));
  const swrFn = () => listIntegrations(accountId, params);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get integration in an account
 */
export const getIntegration = (accountId: string, integrationId: string) => {
  return customAdminApiInstance<Integration>({
    url: `/accounts/${accountId}/integrations/${integrationId}`,
    method: 'GET',
  });
};

export const getGetIntegrationKey = (
  accountId: string,
  integrationId: string,
) => [`/accounts/${accountId}/integrations/${integrationId}`] as const;

export type GetIntegrationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntegration>>
>;
export type GetIntegrationQueryError = unknown;

export const useGetIntegration = <TError = unknown>(
  accountId: string,
  integrationId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getIntegration>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(accountId && integrationId);
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetIntegrationKey(accountId, integrationId) : null));
  const swrFn = () => getIntegration(accountId, integrationId);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * List addon instances in an account
 */
export const listAddonInstances = (
  accountId: string,
  params?: ListAddonInstancesParams,
) => {
  return customAdminApiInstance<ListAddonInstancesResponse>({
    url: `/accounts/${accountId}/addon_instances`,
    method: 'GET',
    params,
  });
};

export const getListAddonInstancesKey = (
  accountId: string,
  params?: ListAddonInstancesParams,
) =>
  [
    `/accounts/${accountId}/addon_instances`,
    ...(params ? [params] : []),
  ] as const;

export type ListAddonInstancesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAddonInstances>>
>;
export type ListAddonInstancesQueryError = unknown;

export const useListAddonInstances = <TError = unknown>(
  accountId: string,
  params?: ListAddonInstancesParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listAddonInstances>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!accountId;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListAddonInstancesKey(accountId, params) : null));
  const swrFn = () => listAddonInstances(accountId, params);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get a specific addon instance in an account
 */
export const getAddonInstance = (
  accountId: string,
  addonInstanceId: string,
) => {
  return customAdminApiInstance<AddonInstance>({
    url: `/accounts/${accountId}/addon_instances/${addonInstanceId}`,
    method: 'GET',
  });
};

export const getGetAddonInstanceKey = (
  accountId: string,
  addonInstanceId: string,
) => [`/accounts/${accountId}/addon_instances/${addonInstanceId}`] as const;

export type GetAddonInstanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAddonInstance>>
>;
export type GetAddonInstanceQueryError = unknown;

export const useGetAddonInstance = <TError = unknown>(
  accountId: string,
  addonInstanceId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getAddonInstance>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(accountId && addonInstanceId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled ? getGetAddonInstanceKey(accountId, addonInstanceId) : null);
  const swrFn = () => getAddonInstance(accountId, addonInstanceId);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * List clusters in an account
 */
export const listClusters = (
  accountId: string,
  params?: ListClustersParams,
) => {
  return customAdminApiInstance<ListClustersResponse>({
    url: `/accounts/${accountId}/clusters`,
    method: 'GET',
    params,
  });
};

export const getListClustersKey = (
  accountId: string,
  params?: ListClustersParams,
) => [`/accounts/${accountId}/clusters`, ...(params ? [params] : [])] as const;

export type ListClustersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listClusters>>
>;
export type ListClustersQueryError = unknown;

export const useListClusters = <TError = unknown>(
  accountId: string,
  params?: ListClustersParams,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof listClusters>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!accountId;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListClustersKey(accountId, params) : null));
  const swrFn = () => listClusters(accountId, params);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Delete a specific cluster in an account
 */
export const deleteCluster = (accountId: string, clusterId: string) => {
  return customAdminApiInstance<void>({
    url: `/accounts/${accountId}/clusters/${clusterId}`,
    method: 'DELETE',
  });
};

export const getDeleteClusterMutationFetcher = (
  accountId: string,
  clusterId: string,
) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteCluster(accountId, clusterId);
  };
};
export const getDeleteClusterMutationKey = (
  accountId: string,
  clusterId: string,
) => [`/accounts/${accountId}/clusters/${clusterId}`] as const;

export type DeleteClusterMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCluster>>
>;
export type DeleteClusterMutationError = void | void;

export const useDeleteCluster = <TError = void | void>(
  accountId: string,
  clusterId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof deleteCluster>>,
      TError,
      Key,
      Arguments,
      Awaited<ReturnType<typeof deleteCluster>>
    > & { swrKey?: string };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getDeleteClusterMutationKey(accountId, clusterId);
  const swrFn = getDeleteClusterMutationFetcher(accountId, clusterId);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get a specific cluster in an account
 */
export const getCluster = (accountId: string, clusterId: string) => {
  return customAdminApiInstance<Cluster>({
    url: `/accounts/${accountId}/clusters/${clusterId}`,
    method: 'GET',
  });
};

export const getGetClusterKey = (accountId: string, clusterId: string) =>
  [`/accounts/${accountId}/clusters/${clusterId}`] as const;

export type GetClusterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCluster>>
>;
export type GetClusterQueryError = unknown;

export const useGetCluster = <TError = unknown>(
  accountId: string,
  clusterId: string,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getCluster>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!(accountId && clusterId);
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetClusterKey(accountId, clusterId) : null));
  const swrFn = () => getCluster(accountId, clusterId);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Update a specific cluster in an account
 */
export const updateCluster = (
  accountId: string,
  clusterId: string,
  updateClusterRequest: UpdateClusterRequest,
) => {
  return customAdminApiInstance<void>({
    url: `/accounts/${accountId}/clusters/${clusterId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateClusterRequest,
  });
};

export const getUpdateClusterMutationFetcher = (
  accountId: string,
  clusterId: string,
) => {
  return (_: Key, { arg }: { arg: UpdateClusterRequest }) => {
    return updateCluster(accountId, clusterId, arg);
  };
};
export const getUpdateClusterMutationKey = (
  accountId: string,
  clusterId: string,
) => [`/accounts/${accountId}/clusters/${clusterId}`] as const;

export type UpdateClusterMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCluster>>
>;
export type UpdateClusterMutationError = unknown;

export const useUpdateCluster = <TError = unknown>(
  accountId: string,
  clusterId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateCluster>>,
      TError,
      Key,
      UpdateClusterRequest,
      Awaited<ReturnType<typeof updateCluster>>
    > & { swrKey?: string };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getUpdateClusterMutationKey(accountId, clusterId);
  const swrFn = getUpdateClusterMutationFetcher(accountId, clusterId);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * List LAR Status' in a cluster
 */
export const listLARStatus = (
  accountId: string,
  clusterId: string,
  params?: ListLARStatusParams,
) => {
  return customAdminApiInstance<ListLARStatusResponse>({
    url: `/accounts/${accountId}/clusters/${clusterId}/lars/status`,
    method: 'GET',
    params,
  });
};

export const getListLARStatusKey = (
  accountId: string,
  clusterId: string,
  params?: ListLARStatusParams,
) =>
  [
    `/accounts/${accountId}/clusters/${clusterId}/lars/status`,
    ...(params ? [params] : []),
  ] as const;

export type ListLARStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLARStatus>>
>;
export type ListLARStatusQueryError = unknown;

export const useListLARStatus = <TError = unknown>(
  accountId: string,
  clusterId: string,
  params?: ListLARStatusParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listLARStatus>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!(accountId && clusterId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled ? getListLARStatusKey(accountId, clusterId, params) : null);
  const swrFn = () => listLARStatus(accountId, clusterId, params);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get LAR Status in a cluster
 */
export const getLARStatus = (
  accountId: string,
  clusterId: string,
  larId: string,
) => {
  return customAdminApiInstance<LARStatus>({
    url: `/accounts/${accountId}/clusters/${clusterId}/lars/status/${larId}`,
    method: 'GET',
  });
};

export const getGetLARStatusKey = (
  accountId: string,
  clusterId: string,
  larId: string,
) =>
  [
    `/accounts/${accountId}/clusters/${clusterId}/lars/status/${larId}`,
  ] as const;

export type GetLARStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLARStatus>>
>;
export type GetLARStatusQueryError = unknown;

export const useGetLARStatus = <TError = unknown>(
  accountId: string,
  clusterId: string,
  larId: string,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getLARStatus>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(accountId && clusterId && larId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled ? getGetLARStatusKey(accountId, clusterId, larId) : null);
  const swrFn = () => getLARStatus(accountId, clusterId, larId);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Update the status of a LAR
 */
export const updateLARStatus = (
  accountId: string,
  clusterId: string,
  larId: string,
  updateLARStatusRequest: UpdateLARStatusRequest,
) => {
  return customAdminApiInstance<void>({
    url: `/accounts/${accountId}/clusters/${clusterId}/lars/status/${larId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateLARStatusRequest,
  });
};

export const getUpdateLARStatusMutationFetcher = (
  accountId: string,
  clusterId: string,
  larId: string,
) => {
  return (_: Key, { arg }: { arg: UpdateLARStatusRequest }) => {
    return updateLARStatus(accountId, clusterId, larId, arg);
  };
};
export const getUpdateLARStatusMutationKey = (
  accountId: string,
  clusterId: string,
  larId: string,
) =>
  [
    `/accounts/${accountId}/clusters/${clusterId}/lars/status/${larId}`,
  ] as const;

export type UpdateLARStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateLARStatus>>
>;
export type UpdateLARStatusMutationError = unknown;

export const useUpdateLARStatus = <TError = unknown>(
  accountId: string,
  clusterId: string,
  larId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateLARStatus>>,
      TError,
      Key,
      UpdateLARStatusRequest,
      Awaited<ReturnType<typeof updateLARStatus>>
    > & { swrKey?: string };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getUpdateLARStatusMutationKey(accountId, clusterId, larId);
  const swrFn = getUpdateLARStatusMutationFetcher(accountId, clusterId, larId);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * List cloud connections in an account
 */
export const listCloudConnections = (
  accountId: string,
  params?: ListCloudConnectionsParams,
) => {
  return customAdminApiInstance<ListCloudConnectionsResponse>({
    url: `/accounts/${accountId}/connection/clouds`,
    method: 'GET',
    params,
  });
};

export const getListCloudConnectionsKey = (
  accountId: string,
  params?: ListCloudConnectionsParams,
) =>
  [
    `/accounts/${accountId}/connection/clouds`,
    ...(params ? [params] : []),
  ] as const;

export type ListCloudConnectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCloudConnections>>
>;
export type ListCloudConnectionsQueryError = unknown;

export const useListCloudConnections = <TError = unknown>(
  accountId: string,
  params?: ListCloudConnectionsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listCloudConnections>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!accountId;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListCloudConnectionsKey(accountId, params) : null));
  const swrFn = () => listCloudConnections(accountId, params);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get a specific cloud connection in an account
 */
export const getCloudConnection = (accountId: string, cloudId: string) => {
  return customAdminApiInstance<CloudConnection>({
    url: `/accounts/${accountId}/connection/clouds/${cloudId}`,
    method: 'GET',
  });
};

export const getGetCloudConnectionKey = (accountId: string, cloudId: string) =>
  [`/accounts/${accountId}/connection/clouds/${cloudId}`] as const;

export type GetCloudConnectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCloudConnection>>
>;
export type GetCloudConnectionQueryError = unknown;

export const useGetCloudConnection = <TError = unknown>(
  accountId: string,
  cloudId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getCloudConnection>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!(accountId && cloudId);
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetCloudConnectionKey(accountId, cloudId) : null));
  const swrFn = () => getCloudConnection(accountId, cloudId);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Create a new action for a cloud connection
 */
export const createCloudConnectionAction = (
  accountId: string,
  cloudId: string,
  createCloudConnectionActionRequest: CreateCloudConnectionActionRequest,
) => {
  return customAdminApiInstance<CloudConnectionAction>({
    url: `/accounts/${accountId}/connection/clouds/${cloudId}/actions`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createCloudConnectionActionRequest,
  });
};

export const getCreateCloudConnectionActionMutationFetcher = (
  accountId: string,
  cloudId: string,
) => {
  return (_: Key, { arg }: { arg: CreateCloudConnectionActionRequest }) => {
    return createCloudConnectionAction(accountId, cloudId, arg);
  };
};
export const getCreateCloudConnectionActionMutationKey = (
  accountId: string,
  cloudId: string,
) => [`/accounts/${accountId}/connection/clouds/${cloudId}/actions`] as const;

export type CreateCloudConnectionActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCloudConnectionAction>>
>;
export type CreateCloudConnectionActionMutationError = unknown;

export const useCreateCloudConnectionAction = <TError = unknown>(
  accountId: string,
  cloudId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof createCloudConnectionAction>>,
      TError,
      Key,
      CreateCloudConnectionActionRequest,
      Awaited<ReturnType<typeof createCloudConnectionAction>>
    > & { swrKey?: string };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getCreateCloudConnectionActionMutationKey(accountId, cloudId);
  const swrFn = getCreateCloudConnectionActionMutationFetcher(
    accountId,
    cloudId,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * List upgrades in an account
 */
export const listUpgrades = (
  accountId: string,
  params?: ListUpgradesParams,
) => {
  return customAdminApiInstance<ListUpgradePlansResponse>({
    url: `/accounts/${accountId}/upgrades`,
    method: 'GET',
    params,
  });
};

export const getListUpgradesKey = (
  accountId: string,
  params?: ListUpgradesParams,
) => [`/accounts/${accountId}/upgrades`, ...(params ? [params] : [])] as const;

export type ListUpgradesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgrades>>
>;
export type ListUpgradesQueryError = unknown;

export const useListUpgrades = <TError = unknown>(
  accountId: string,
  params?: ListUpgradesParams,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof listUpgrades>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!accountId;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListUpgradesKey(accountId, params) : null));
  const swrFn = () => listUpgrades(accountId, params);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get upgrade in an account
 */
export const getUpgrade = (accountId: string, upgradeId: string) => {
  return customAdminApiInstance<UpgradePlanAdminView>({
    url: `/accounts/${accountId}/upgrades/${upgradeId}`,
    method: 'GET',
  });
};

export const getGetUpgradeKey = (accountId: string, upgradeId: string) =>
  [`/accounts/${accountId}/upgrades/${upgradeId}`] as const;

export type GetUpgradeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpgrade>>
>;
export type GetUpgradeQueryError = unknown;

export const useGetUpgrade = <TError = unknown>(
  accountId: string,
  upgradeId: string,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getUpgrade>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!(accountId && upgradeId);
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetUpgradeKey(accountId, upgradeId) : null));
  const swrFn = () => getUpgrade(accountId, upgradeId);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Update an upgrade in an account
 */
export const updateUpgrade = (
  accountId: string,
  upgradeId: string,
  updateUpgradePlanRequest: UpdateUpgradePlanRequest,
) => {
  return customAdminApiInstance<UpgradePlanAdminView>({
    url: `/accounts/${accountId}/upgrades/${upgradeId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateUpgradePlanRequest,
  });
};

export const getUpdateUpgradeMutationFetcher = (
  accountId: string,
  upgradeId: string,
) => {
  return (_: Key, { arg }: { arg: UpdateUpgradePlanRequest }) => {
    return updateUpgrade(accountId, upgradeId, arg);
  };
};
export const getUpdateUpgradeMutationKey = (
  accountId: string,
  upgradeId: string,
) => [`/accounts/${accountId}/upgrades/${upgradeId}`] as const;

export type UpdateUpgradeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUpgrade>>
>;
export type UpdateUpgradeMutationError = unknown;

export const useUpdateUpgrade = <TError = unknown>(
  accountId: string,
  upgradeId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateUpgrade>>,
      TError,
      Key,
      UpdateUpgradePlanRequest,
      Awaited<ReturnType<typeof updateUpgrade>>
    > & { swrKey?: string };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getUpdateUpgradeMutationKey(accountId, upgradeId);
  const swrFn = getUpdateUpgradeMutationFetcher(accountId, upgradeId);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * get the engine result (including stages)
 */
export const getUpgradeEngineResult = (
  accountId: string,
  upgradeId: string,
) => {
  return customAdminApiInstance<UpgradePlanGenerationOutputDocument>({
    url: `/accounts/${accountId}/upgrades/${upgradeId}/engine_result`,
    method: 'GET',
  });
};

export const getGetUpgradeEngineResultKey = (
  accountId: string,
  upgradeId: string,
) => [`/accounts/${accountId}/upgrades/${upgradeId}/engine_result`] as const;

export type GetUpgradeEngineResultQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpgradeEngineResult>>
>;
export type GetUpgradeEngineResultQueryError = unknown;

export const useGetUpgradeEngineResult = <TError = unknown>(
  accountId: string,
  upgradeId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getUpgradeEngineResult>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!(accountId && upgradeId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled ? getGetUpgradeEngineResultKey(accountId, upgradeId) : null);
  const swrFn = () => getUpgradeEngineResult(accountId, upgradeId);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * update the engine result (including stages)
 */
export const updateUpgradeEngineResult = (
  accountId: string,
  upgradeId: string,
  upgradePlanGenerationOutputDocument: UpgradePlanGenerationOutputDocument,
) => {
  return customAdminApiInstance<void>({
    url: `/accounts/${accountId}/upgrades/${upgradeId}/engine_result`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: upgradePlanGenerationOutputDocument,
  });
};

export const getUpdateUpgradeEngineResultMutationFetcher = (
  accountId: string,
  upgradeId: string,
) => {
  return (_: Key, { arg }: { arg: UpgradePlanGenerationOutputDocument }) => {
    return updateUpgradeEngineResult(accountId, upgradeId, arg);
  };
};
export const getUpdateUpgradeEngineResultMutationKey = (
  accountId: string,
  upgradeId: string,
) => [`/accounts/${accountId}/upgrades/${upgradeId}/engine_result`] as const;

export type UpdateUpgradeEngineResultMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUpgradeEngineResult>>
>;
export type UpdateUpgradeEngineResultMutationError = unknown;

export const useUpdateUpgradeEngineResult = <TError = unknown>(
  accountId: string,
  upgradeId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateUpgradeEngineResult>>,
      TError,
      Key,
      UpgradePlanGenerationOutputDocument,
      Awaited<ReturnType<typeof updateUpgradeEngineResult>>
    > & { swrKey?: string };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getUpdateUpgradeEngineResultMutationKey(accountId, upgradeId);
  const swrFn = getUpdateUpgradeEngineResultMutationFetcher(
    accountId,
    upgradeId,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * list the stages for this upgrade
 */
export const listUpgradeStages = (accountId: string, upgradeId: string) => {
  return customAdminApiInstance<ListUpgradePlanStagesResponse>({
    url: `/accounts/${accountId}/upgrades/${upgradeId}/stages`,
    method: 'GET',
  });
};

export const getListUpgradeStagesKey = (accountId: string, upgradeId: string) =>
  [`/accounts/${accountId}/upgrades/${upgradeId}/stages`] as const;

export type ListUpgradeStagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradeStages>>
>;
export type ListUpgradeStagesQueryError = unknown;

export const useListUpgradeStages = <TError = unknown>(
  accountId: string,
  upgradeId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradeStages>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!(accountId && upgradeId);
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListUpgradeStagesKey(accountId, upgradeId) : null));
  const swrFn = () => listUpgradeStages(accountId, upgradeId);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * create stages for this upgrade - will fail if stages already exist
 */
export const createUpgradeStages = (
  accountId: string,
  upgradeId: string,
  createUpgradePlanStagesRequest: CreateUpgradePlanStagesRequest,
) => {
  return customAdminApiInstance<void>({
    url: `/accounts/${accountId}/upgrades/${upgradeId}/stages`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createUpgradePlanStagesRequest,
  });
};

export const getCreateUpgradeStagesMutationFetcher = (
  accountId: string,
  upgradeId: string,
) => {
  return (_: Key, { arg }: { arg: CreateUpgradePlanStagesRequest }) => {
    return createUpgradeStages(accountId, upgradeId, arg);
  };
};
export const getCreateUpgradeStagesMutationKey = (
  accountId: string,
  upgradeId: string,
) => [`/accounts/${accountId}/upgrades/${upgradeId}/stages`] as const;

export type CreateUpgradeStagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUpgradeStages>>
>;
export type CreateUpgradeStagesMutationError = unknown;

export const useCreateUpgradeStages = <TError = unknown>(
  accountId: string,
  upgradeId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof createUpgradeStages>>,
      TError,
      Key,
      CreateUpgradePlanStagesRequest,
      Awaited<ReturnType<typeof createUpgradeStages>>
    > & { swrKey?: string };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getCreateUpgradeStagesMutationKey(accountId, upgradeId);
  const swrFn = getCreateUpgradeStagesMutationFetcher(accountId, upgradeId);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * update stages for this upgrade - will fail if stages already exist
 */
export const updateUpgradeStages = (
  accountId: string,
  upgradeId: string,
  updateUpgradePlanStagesRequest: UpdateUpgradePlanStagesRequest,
) => {
  return customAdminApiInstance<void>({
    url: `/accounts/${accountId}/upgrades/${upgradeId}/stages`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateUpgradePlanStagesRequest,
  });
};

export const getUpdateUpgradeStagesMutationFetcher = (
  accountId: string,
  upgradeId: string,
) => {
  return (_: Key, { arg }: { arg: UpdateUpgradePlanStagesRequest }) => {
    return updateUpgradeStages(accountId, upgradeId, arg);
  };
};
export const getUpdateUpgradeStagesMutationKey = (
  accountId: string,
  upgradeId: string,
) => [`/accounts/${accountId}/upgrades/${upgradeId}/stages`] as const;

export type UpdateUpgradeStagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUpgradeStages>>
>;
export type UpdateUpgradeStagesMutationError = unknown;

export const useUpdateUpgradeStages = <TError = unknown>(
  accountId: string,
  upgradeId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateUpgradeStages>>,
      TError,
      Key,
      UpdateUpgradePlanStagesRequest,
      Awaited<ReturnType<typeof updateUpgradeStages>>
    > & { swrKey?: string };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getUpdateUpgradeStagesMutationKey(accountId, upgradeId);
  const swrFn = getUpdateUpgradeStagesMutationFetcher(accountId, upgradeId);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * List upgrades across all organizations and accounts
 */
export const globalListUpgrades = (params?: GlobalListUpgradesParams) => {
  return customAdminApiInstance<ListUpgradePlansResponse>({
    url: `/upgrades`,
    method: 'GET',
    params,
  });
};

export const getGlobalListUpgradesKey = (params?: GlobalListUpgradesParams) =>
  [`/upgrades`, ...(params ? [params] : [])] as const;

export type GlobalListUpgradesQueryResult = NonNullable<
  Awaited<ReturnType<typeof globalListUpgrades>>
>;
export type GlobalListUpgradesQueryError = unknown;

export const useGlobalListUpgrades = <TError = unknown>(
  params?: GlobalListUpgradesParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof globalListUpgrades>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGlobalListUpgradesKey(params) : null));
  const swrFn = () => globalListUpgrades(params);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * List upgrade templates in an account
 */
export const listUpgradeTemplates = (
  accountId: string,
  params?: ListUpgradeTemplatesParams,
) => {
  return customAdminApiInstance<ListUpgradeTemplatesResponse>({
    url: `/accounts/${accountId}/upgrade_templates`,
    method: 'GET',
    params,
  });
};

export const getListUpgradeTemplatesKey = (
  accountId: string,
  params?: ListUpgradeTemplatesParams,
) =>
  [
    `/accounts/${accountId}/upgrade_templates`,
    ...(params ? [params] : []),
  ] as const;

export type ListUpgradeTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradeTemplates>>
>;
export type ListUpgradeTemplatesQueryError = unknown;

export const useListUpgradeTemplates = <TError = unknown>(
  accountId: string,
  params?: ListUpgradeTemplatesParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradeTemplates>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!accountId;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListUpgradeTemplatesKey(accountId, params) : null));
  const swrFn = () => listUpgradeTemplates(accountId, params);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get upgrade template in an account
 */
export const getUpgradeTemplate = (
  accountId: string,
  upgradeTemplateId: string,
) => {
  return customAdminApiInstance<UpgradeTemplateAdminView>({
    url: `/accounts/${accountId}/upgrade_templates/${upgradeTemplateId}`,
    method: 'GET',
  });
};

export const getGetUpgradeTemplateKey = (
  accountId: string,
  upgradeTemplateId: string,
) => [`/accounts/${accountId}/upgrade_templates/${upgradeTemplateId}`] as const;

export type GetUpgradeTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpgradeTemplate>>
>;
export type GetUpgradeTemplateQueryError = unknown;

export const useGetUpgradeTemplate = <TError = unknown>(
  accountId: string,
  upgradeTemplateId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getUpgradeTemplate>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(accountId && upgradeTemplateId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getGetUpgradeTemplateKey(accountId, upgradeTemplateId)
        : null);
  const swrFn = () => getUpgradeTemplate(accountId, upgradeTemplateId);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Update an upgrade in an account
 */
export const updateUpgradeTemplate = (
  accountId: string,
  upgradeTemplateId: string,
  updateUpgradeTemplateRequest: UpdateUpgradeTemplateRequest,
) => {
  return customAdminApiInstance<UpgradeTemplateAdminView>({
    url: `/accounts/${accountId}/upgrade_templates/${upgradeTemplateId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateUpgradeTemplateRequest,
  });
};

export const getUpdateUpgradeTemplateMutationFetcher = (
  accountId: string,
  upgradeTemplateId: string,
) => {
  return (_: Key, { arg }: { arg: UpdateUpgradeTemplateRequest }) => {
    return updateUpgradeTemplate(accountId, upgradeTemplateId, arg);
  };
};
export const getUpdateUpgradeTemplateMutationKey = (
  accountId: string,
  upgradeTemplateId: string,
) => [`/accounts/${accountId}/upgrade_templates/${upgradeTemplateId}`] as const;

export type UpdateUpgradeTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUpgradeTemplate>>
>;
export type UpdateUpgradeTemplateMutationError = unknown;

export const useUpdateUpgradeTemplate = <TError = unknown>(
  accountId: string,
  upgradeTemplateId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateUpgradeTemplate>>,
      TError,
      Key,
      UpdateUpgradeTemplateRequest,
      Awaited<ReturnType<typeof updateUpgradeTemplate>>
    > & { swrKey?: string };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getUpdateUpgradeTemplateMutationKey(accountId, upgradeTemplateId);
  const swrFn = getUpdateUpgradeTemplateMutationFetcher(
    accountId,
    upgradeTemplateId,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * get the engine result (including stages)
 */
export const getUpgradeTemplateEngineResult = (
  accountId: string,
  upgradeTemplateId: string,
) => {
  return customAdminApiInstance<UpgradeTemplateGenerationOutputDocument>({
    url: `/accounts/${accountId}/upgrade_templates/${upgradeTemplateId}/engine_result`,
    method: 'GET',
  });
};

export const getGetUpgradeTemplateEngineResultKey = (
  accountId: string,
  upgradeTemplateId: string,
) =>
  [
    `/accounts/${accountId}/upgrade_templates/${upgradeTemplateId}/engine_result`,
  ] as const;

export type GetUpgradeTemplateEngineResultQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpgradeTemplateEngineResult>>
>;
export type GetUpgradeTemplateEngineResultQueryError = unknown;

export const useGetUpgradeTemplateEngineResult = <TError = unknown>(
  accountId: string,
  upgradeTemplateId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getUpgradeTemplateEngineResult>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(accountId && upgradeTemplateId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getGetUpgradeTemplateEngineResultKey(accountId, upgradeTemplateId)
        : null);
  const swrFn = () =>
    getUpgradeTemplateEngineResult(accountId, upgradeTemplateId);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * update the engine result (including stages)
 */
export const updateUpgradeTemplateEngineResult = (
  accountId: string,
  upgradeTemplateId: string,
  upgradeTemplateGenerationOutputDocument: UpgradeTemplateGenerationOutputDocument,
) => {
  return customAdminApiInstance<void>({
    url: `/accounts/${accountId}/upgrade_templates/${upgradeTemplateId}/engine_result`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: upgradeTemplateGenerationOutputDocument,
  });
};

export const getUpdateUpgradeTemplateEngineResultMutationFetcher = (
  accountId: string,
  upgradeTemplateId: string,
) => {
  return (
    _: Key,
    { arg }: { arg: UpgradeTemplateGenerationOutputDocument },
  ) => {
    return updateUpgradeTemplateEngineResult(accountId, upgradeTemplateId, arg);
  };
};
export const getUpdateUpgradeTemplateEngineResultMutationKey = (
  accountId: string,
  upgradeTemplateId: string,
) =>
  [
    `/accounts/${accountId}/upgrade_templates/${upgradeTemplateId}/engine_result`,
  ] as const;

export type UpdateUpgradeTemplateEngineResultMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUpgradeTemplateEngineResult>>
>;
export type UpdateUpgradeTemplateEngineResultMutationError = unknown;

export const useUpdateUpgradeTemplateEngineResult = <TError = unknown>(
  accountId: string,
  upgradeTemplateId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateUpgradeTemplateEngineResult>>,
      TError,
      Key,
      UpgradeTemplateGenerationOutputDocument,
      Awaited<ReturnType<typeof updateUpgradeTemplateEngineResult>>
    > & { swrKey?: string };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getUpdateUpgradeTemplateEngineResultMutationKey(
      accountId,
      upgradeTemplateId,
    );
  const swrFn = getUpdateUpgradeTemplateEngineResultMutationFetcher(
    accountId,
    upgradeTemplateId,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get the selections (upgrade recommendations) for the Upgrade Template
 */
export const getUpgradeTemplateSelections = (
  accountId: string,
  upgradeTemplateId: string,
) => {
  return customAdminApiInstance<UpgradeSelections>({
    url: `/accounts/${accountId}/upgrade_templates/${upgradeTemplateId}/selections`,
    method: 'GET',
  });
};

export const getGetUpgradeTemplateSelectionsKey = (
  accountId: string,
  upgradeTemplateId: string,
) =>
  [
    `/accounts/${accountId}/upgrade_templates/${upgradeTemplateId}/selections`,
  ] as const;

export type GetUpgradeTemplateSelectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpgradeTemplateSelections>>
>;
export type GetUpgradeTemplateSelectionsQueryError = unknown;

export const useGetUpgradeTemplateSelections = <TError = unknown>(
  accountId: string,
  upgradeTemplateId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getUpgradeTemplateSelections>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(accountId && upgradeTemplateId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getGetUpgradeTemplateSelectionsKey(accountId, upgradeTemplateId)
        : null);
  const swrFn = () =>
    getUpgradeTemplateSelections(accountId, upgradeTemplateId);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Update the selections (upgrade recommendations) for the Upgrade Template
 */
export const updateUpgradeTemplateSelections = (
  accountId: string,
  upgradeTemplateId: string,
  upgradeSelections: UpgradeSelections,
) => {
  return customAdminApiInstance<void>({
    url: `/accounts/${accountId}/upgrade_templates/${upgradeTemplateId}/selections`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/x-yaml' },
    data: upgradeSelections,
  });
};

export const getUpdateUpgradeTemplateSelectionsMutationFetcher = (
  accountId: string,
  upgradeTemplateId: string,
) => {
  return (_: Key, { arg }: { arg: UpgradeSelections }) => {
    return updateUpgradeTemplateSelections(accountId, upgradeTemplateId, arg);
  };
};
export const getUpdateUpgradeTemplateSelectionsMutationKey = (
  accountId: string,
  upgradeTemplateId: string,
) =>
  [
    `/accounts/${accountId}/upgrade_templates/${upgradeTemplateId}/selections`,
  ] as const;

export type UpdateUpgradeTemplateSelectionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUpgradeTemplateSelections>>
>;
export type UpdateUpgradeTemplateSelectionsMutationError = unknown;

export const useUpdateUpgradeTemplateSelections = <TError = unknown>(
  accountId: string,
  upgradeTemplateId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateUpgradeTemplateSelections>>,
      TError,
      Key,
      UpgradeSelections,
      Awaited<ReturnType<typeof updateUpgradeTemplateSelections>>
    > & { swrKey?: string };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getUpdateUpgradeTemplateSelectionsMutationKey(accountId, upgradeTemplateId);
  const swrFn = getUpdateUpgradeTemplateSelectionsMutationFetcher(
    accountId,
    upgradeTemplateId,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * list the stages for this upgrade template
 */
export const listUpgradeTemplateStages = (
  accountId: string,
  upgradeTemplateId: string,
) => {
  return customAdminApiInstance<ListUpgradeTemplateStagesResponse>({
    url: `/accounts/${accountId}/upgrade_templates/${upgradeTemplateId}/stages`,
    method: 'GET',
  });
};

export const getListUpgradeTemplateStagesKey = (
  accountId: string,
  upgradeTemplateId: string,
) =>
  [
    `/accounts/${accountId}/upgrade_templates/${upgradeTemplateId}/stages`,
  ] as const;

export type ListUpgradeTemplateStagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradeTemplateStages>>
>;
export type ListUpgradeTemplateStagesQueryError = unknown;

export const useListUpgradeTemplateStages = <TError = unknown>(
  accountId: string,
  upgradeTemplateId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradeTemplateStages>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(accountId && upgradeTemplateId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getListUpgradeTemplateStagesKey(accountId, upgradeTemplateId)
        : null);
  const swrFn = () => listUpgradeTemplateStages(accountId, upgradeTemplateId);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * create stages for this upgrade template - will fail if stages already exist
 */
export const createUpgradeTemplateStages = (
  accountId: string,
  upgradeTemplateId: string,
  createUpgradeTemplateStagesRequest: CreateUpgradeTemplateStagesRequest,
) => {
  return customAdminApiInstance<void>({
    url: `/accounts/${accountId}/upgrade_templates/${upgradeTemplateId}/stages`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createUpgradeTemplateStagesRequest,
  });
};

export const getCreateUpgradeTemplateStagesMutationFetcher = (
  accountId: string,
  upgradeTemplateId: string,
) => {
  return (_: Key, { arg }: { arg: CreateUpgradeTemplateStagesRequest }) => {
    return createUpgradeTemplateStages(accountId, upgradeTemplateId, arg);
  };
};
export const getCreateUpgradeTemplateStagesMutationKey = (
  accountId: string,
  upgradeTemplateId: string,
) =>
  [
    `/accounts/${accountId}/upgrade_templates/${upgradeTemplateId}/stages`,
  ] as const;

export type CreateUpgradeTemplateStagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUpgradeTemplateStages>>
>;
export type CreateUpgradeTemplateStagesMutationError = unknown;

export const useCreateUpgradeTemplateStages = <TError = unknown>(
  accountId: string,
  upgradeTemplateId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof createUpgradeTemplateStages>>,
      TError,
      Key,
      CreateUpgradeTemplateStagesRequest,
      Awaited<ReturnType<typeof createUpgradeTemplateStages>>
    > & { swrKey?: string };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getCreateUpgradeTemplateStagesMutationKey(accountId, upgradeTemplateId);
  const swrFn = getCreateUpgradeTemplateStagesMutationFetcher(
    accountId,
    upgradeTemplateId,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * update stages for this upgrade template
 */
export const updateUpgradeTemplateStages = (
  accountId: string,
  upgradeTemplateId: string,
  updateUpgradeTemplateStagesRequest: UpdateUpgradeTemplateStagesRequest,
) => {
  return customAdminApiInstance<void>({
    url: `/accounts/${accountId}/upgrade_templates/${upgradeTemplateId}/stages`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateUpgradeTemplateStagesRequest,
  });
};

export const getUpdateUpgradeTemplateStagesMutationFetcher = (
  accountId: string,
  upgradeTemplateId: string,
) => {
  return (_: Key, { arg }: { arg: UpdateUpgradeTemplateStagesRequest }) => {
    return updateUpgradeTemplateStages(accountId, upgradeTemplateId, arg);
  };
};
export const getUpdateUpgradeTemplateStagesMutationKey = (
  accountId: string,
  upgradeTemplateId: string,
) =>
  [
    `/accounts/${accountId}/upgrade_templates/${upgradeTemplateId}/stages`,
  ] as const;

export type UpdateUpgradeTemplateStagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUpgradeTemplateStages>>
>;
export type UpdateUpgradeTemplateStagesMutationError = unknown;

export const useUpdateUpgradeTemplateStages = <TError = unknown>(
  accountId: string,
  upgradeTemplateId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateUpgradeTemplateStages>>,
      TError,
      Key,
      UpdateUpgradeTemplateStagesRequest,
      Awaited<ReturnType<typeof updateUpgradeTemplateStages>>
    > & { swrKey?: string };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getUpdateUpgradeTemplateStagesMutationKey(accountId, upgradeTemplateId);
  const swrFn = getUpdateUpgradeTemplateStagesMutationFetcher(
    accountId,
    upgradeTemplateId,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * List upgrade templates across all organizations and accounts
 */
export const globalListUpgradeTemplates = (
  params?: GlobalListUpgradeTemplatesParams,
) => {
  return customAdminApiInstance<ListUpgradeTemplatesResponse>({
    url: `/upgrade_templates`,
    method: 'GET',
    params,
  });
};

export const getGlobalListUpgradeTemplatesKey = (
  params?: GlobalListUpgradeTemplatesParams,
) => [`/upgrade_templates`, ...(params ? [params] : [])] as const;

export type GlobalListUpgradeTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof globalListUpgradeTemplates>>
>;
export type GlobalListUpgradeTemplatesQueryError = unknown;

export const useGlobalListUpgradeTemplates = <TError = unknown>(
  params?: GlobalListUpgradeTemplatesParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof globalListUpgradeTemplates>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGlobalListUpgradeTemplatesKey(params) : null));
  const swrFn = () => globalListUpgradeTemplates(params);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * List upgrade assessments in an account
 */
export const listUpgradeAssessments = (
  accountId: string,
  params?: ListUpgradeAssessmentsParams,
) => {
  return customAdminApiInstance<ListUpgradeAssessmentsResponse>({
    url: `/accounts/${accountId}/upgrade_assessments`,
    method: 'GET',
    params,
  });
};

export const getListUpgradeAssessmentsKey = (
  accountId: string,
  params?: ListUpgradeAssessmentsParams,
) =>
  [
    `/accounts/${accountId}/upgrade_assessments`,
    ...(params ? [params] : []),
  ] as const;

export type ListUpgradeAssessmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradeAssessments>>
>;
export type ListUpgradeAssessmentsQueryError = unknown;

export const useListUpgradeAssessments = <TError = unknown>(
  accountId: string,
  params?: ListUpgradeAssessmentsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradeAssessments>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!accountId;
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled ? getListUpgradeAssessmentsKey(accountId, params) : null);
  const swrFn = () => listUpgradeAssessments(accountId, params);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get upgrade assessment in an account
 */
export const getUpgradeAssessment = (
  accountId: string,
  upgradeAssessmentId: string,
) => {
  return customAdminApiInstance<UpgradeAssessmentAdminView>({
    url: `/accounts/${accountId}/upgrade_assessments/${upgradeAssessmentId}`,
    method: 'GET',
  });
};

export const getGetUpgradeAssessmentKey = (
  accountId: string,
  upgradeAssessmentId: string,
) =>
  [
    `/accounts/${accountId}/upgrade_assessments/${upgradeAssessmentId}`,
  ] as const;

export type GetUpgradeAssessmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpgradeAssessment>>
>;
export type GetUpgradeAssessmentQueryError = unknown;

export const useGetUpgradeAssessment = <TError = unknown>(
  accountId: string,
  upgradeAssessmentId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getUpgradeAssessment>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(accountId && upgradeAssessmentId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getGetUpgradeAssessmentKey(accountId, upgradeAssessmentId)
        : null);
  const swrFn = () => getUpgradeAssessment(accountId, upgradeAssessmentId);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Update an upgrade assessment in an account
 */
export const updateUpgradeAssessment = (
  accountId: string,
  upgradeAssessmentId: string,
  updateUpgradeAssessmentRequest: UpdateUpgradeAssessmentRequest,
) => {
  return customAdminApiInstance<UpgradeAssessmentAdminView>({
    url: `/accounts/${accountId}/upgrade_assessments/${upgradeAssessmentId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateUpgradeAssessmentRequest,
  });
};

export const getUpdateUpgradeAssessmentMutationFetcher = (
  accountId: string,
  upgradeAssessmentId: string,
) => {
  return (_: Key, { arg }: { arg: UpdateUpgradeAssessmentRequest }) => {
    return updateUpgradeAssessment(accountId, upgradeAssessmentId, arg);
  };
};
export const getUpdateUpgradeAssessmentMutationKey = (
  accountId: string,
  upgradeAssessmentId: string,
) =>
  [
    `/accounts/${accountId}/upgrade_assessments/${upgradeAssessmentId}`,
  ] as const;

export type UpdateUpgradeAssessmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUpgradeAssessment>>
>;
export type UpdateUpgradeAssessmentMutationError = unknown;

export const useUpdateUpgradeAssessment = <TError = unknown>(
  accountId: string,
  upgradeAssessmentId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateUpgradeAssessment>>,
      TError,
      Key,
      UpdateUpgradeAssessmentRequest,
      Awaited<ReturnType<typeof updateUpgradeAssessment>>
    > & { swrKey?: string };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getUpdateUpgradeAssessmentMutationKey(accountId, upgradeAssessmentId);
  const swrFn = getUpdateUpgradeAssessmentMutationFetcher(
    accountId,
    upgradeAssessmentId,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * update the engine result (including stages)
 */
export const updateUpgradeAssessmentEngineResult = (
  accountId: string,
  upgradeAssessmentId: string,
  upgradeAssessmentGenerationOutputDocument: UpgradeAssessmentGenerationOutputDocument,
) => {
  return customAdminApiInstance<void>({
    url: `/accounts/${accountId}/upgrade_assessments/${upgradeAssessmentId}/engine_result`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: upgradeAssessmentGenerationOutputDocument,
  });
};

export const getUpdateUpgradeAssessmentEngineResultMutationFetcher = (
  accountId: string,
  upgradeAssessmentId: string,
) => {
  return (
    _: Key,
    { arg }: { arg: UpgradeAssessmentGenerationOutputDocument },
  ) => {
    return updateUpgradeAssessmentEngineResult(
      accountId,
      upgradeAssessmentId,
      arg,
    );
  };
};
export const getUpdateUpgradeAssessmentEngineResultMutationKey = (
  accountId: string,
  upgradeAssessmentId: string,
) =>
  [
    `/accounts/${accountId}/upgrade_assessments/${upgradeAssessmentId}/engine_result`,
  ] as const;

export type UpdateUpgradeAssessmentEngineResultMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUpgradeAssessmentEngineResult>>
>;
export type UpdateUpgradeAssessmentEngineResultMutationError = unknown;

export const useUpdateUpgradeAssessmentEngineResult = <TError = unknown>(
  accountId: string,
  upgradeAssessmentId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateUpgradeAssessmentEngineResult>>,
      TError,
      Key,
      UpgradeAssessmentGenerationOutputDocument,
      Awaited<ReturnType<typeof updateUpgradeAssessmentEngineResult>>
    > & { swrKey?: string };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getUpdateUpgradeAssessmentEngineResultMutationKey(
      accountId,
      upgradeAssessmentId,
    );
  const swrFn = getUpdateUpgradeAssessmentEngineResultMutationFetcher(
    accountId,
    upgradeAssessmentId,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * list the stages for this upgrade assessment
 */
export const listUpgradeAssessmentStages = (
  accountId: string,
  upgradeAssessmentId: string,
) => {
  return customAdminApiInstance<ListUpgradeAssessmentStagesResponse>({
    url: `/accounts/${accountId}/upgrade_assessments/${upgradeAssessmentId}/stages`,
    method: 'GET',
  });
};

export const getListUpgradeAssessmentStagesKey = (
  accountId: string,
  upgradeAssessmentId: string,
) =>
  [
    `/accounts/${accountId}/upgrade_assessments/${upgradeAssessmentId}/stages`,
  ] as const;

export type ListUpgradeAssessmentStagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradeAssessmentStages>>
>;
export type ListUpgradeAssessmentStagesQueryError = unknown;

export const useListUpgradeAssessmentStages = <TError = unknown>(
  accountId: string,
  upgradeAssessmentId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradeAssessmentStages>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(accountId && upgradeAssessmentId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getListUpgradeAssessmentStagesKey(accountId, upgradeAssessmentId)
        : null);
  const swrFn = () =>
    listUpgradeAssessmentStages(accountId, upgradeAssessmentId);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * update stages for this upgrade assessment
 */
export const updateUpgradeAssessmentStages = (
  accountId: string,
  upgradeAssessmentId: string,
  updateUpgradeAssessmentStagesRequest: UpdateUpgradeAssessmentStagesRequest,
) => {
  return customAdminApiInstance<void>({
    url: `/accounts/${accountId}/upgrade_assessments/${upgradeAssessmentId}/stages`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateUpgradeAssessmentStagesRequest,
  });
};

export const getUpdateUpgradeAssessmentStagesMutationFetcher = (
  accountId: string,
  upgradeAssessmentId: string,
) => {
  return (_: Key, { arg }: { arg: UpdateUpgradeAssessmentStagesRequest }) => {
    return updateUpgradeAssessmentStages(accountId, upgradeAssessmentId, arg);
  };
};
export const getUpdateUpgradeAssessmentStagesMutationKey = (
  accountId: string,
  upgradeAssessmentId: string,
) =>
  [
    `/accounts/${accountId}/upgrade_assessments/${upgradeAssessmentId}/stages`,
  ] as const;

export type UpdateUpgradeAssessmentStagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUpgradeAssessmentStages>>
>;
export type UpdateUpgradeAssessmentStagesMutationError = unknown;

export const useUpdateUpgradeAssessmentStages = <TError = unknown>(
  accountId: string,
  upgradeAssessmentId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateUpgradeAssessmentStages>>,
      TError,
      Key,
      UpdateUpgradeAssessmentStagesRequest,
      Awaited<ReturnType<typeof updateUpgradeAssessmentStages>>
    > & { swrKey?: string };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getUpdateUpgradeAssessmentStagesMutationKey(accountId, upgradeAssessmentId);
  const swrFn = getUpdateUpgradeAssessmentStagesMutationFetcher(
    accountId,
    upgradeAssessmentId,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * List upgrade assessments across all organizations and accounts
 */
export const globalListUpgradeAssessments = (
  params?: GlobalListUpgradeAssessmentsParams,
) => {
  return customAdminApiInstance<ListUpgradeAssessmentsResponse>({
    url: `/upgrade_assessments`,
    method: 'GET',
    params,
  });
};

export const getGlobalListUpgradeAssessmentsKey = (
  params?: GlobalListUpgradeAssessmentsParams,
) => [`/upgrade_assessments`, ...(params ? [params] : [])] as const;

export type GlobalListUpgradeAssessmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof globalListUpgradeAssessments>>
>;
export type GlobalListUpgradeAssessmentsQueryError = unknown;

export const useGlobalListUpgradeAssessments = <TError = unknown>(
  params?: GlobalListUpgradeAssessmentsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof globalListUpgradeAssessments>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGlobalListUpgradeAssessmentsKey(params) : null));
  const swrFn = () => globalListUpgradeAssessments(params);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * List addons defined in AddonHub
 */
export const listAddons = (params?: ListAddonsParams) => {
  return customAdminApiInstance<ListAddonResponse>({
    url: `/addons`,
    method: 'GET',
    params,
  });
};

export const getListAddonsKey = (params?: ListAddonsParams) =>
  [`/addons`, ...(params ? [params] : [])] as const;

export type ListAddonsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAddons>>
>;
export type ListAddonsQueryError = unknown;

export const useListAddons = <TError = unknown>(
  params?: ListAddonsParams,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof listAddons>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getListAddonsKey(params) : null));
  const swrFn = () => listAddons(params);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get details for a specific addon from AddonHub
 */
export const getAddon = (addonId: string) => {
  return customAdminApiInstance<Addon>({
    url: `/addons/${addonId}`,
    method: 'GET',
  });
};

export const getGetAddonKey = (addonId: string) =>
  [`/addons/${addonId}`] as const;

export type GetAddonQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAddon>>
>;
export type GetAddonQueryError = unknown;

export const useGetAddon = <TError = unknown>(
  addonId: string,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getAddon>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!addonId;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getGetAddonKey(addonId) : null));
  const swrFn = () => getAddon(addonId);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get details for a specific addon image from AddonHub
 */
export const getAddonImage = (imageHash: string) => {
  return customAdminApiInstance<AddonImageDetails>({
    url: `/addon_images/${imageHash}`,
    method: 'GET',
  });
};

export const getGetAddonImageKey = (imageHash: string) =>
  [`/addon_images/${imageHash}`] as const;

export type GetAddonImageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAddonImage>>
>;
export type GetAddonImageQueryError = unknown;

export const useGetAddonImage = <TError = unknown>(
  imageHash: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getAddonImage>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!imageHash;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetAddonImageKey(imageHash) : null));
  const swrFn = () => getAddonImage(imageHash);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * List users based on filters provided in the query parameters
 */
export const listUsers = (params?: ListUsersParams) => {
  return customAdminApiInstance<ListUserResponse>({
    url: `/users`,
    method: 'GET',
    params,
  });
};

export const getListUsersKey = (params?: ListUsersParams) =>
  [`/users`, ...(params ? [params] : [])] as const;

export type ListUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUsers>>
>;
export type ListUsersQueryError = unknown;

export const useListUsers = <TError = unknown>(
  params?: ListUsersParams,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof listUsers>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getListUsersKey(params) : null));
  const swrFn = () => listUsers(params);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Endpoint to get user's state in DB
 */
export const getUser = (userId: string) => {
  return customAdminApiInstance<User>({
    url: `/users/${userId}`,
    method: 'GET',
  });
};

export const getGetUserKey = (userId: string) => [`/users/${userId}`] as const;

export type GetUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUser>>
>;
export type GetUserQueryError = unknown;

export const useGetUser = <TError = unknown>(
  userId: string,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getUser>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
  },
) => {
  const { swr: swrOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!userId;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getGetUserKey(userId) : null));
  const swrFn = () => getUser(userId);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};
